import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ValOrDash from "../../components/ValOrDash";
import AddressFormatted from "../../components/AddressFormatted";
const DebtorDefinitionList = ({ debtor }) => {
    return (_jsxs("dl", { children: [_jsx("dt", { children: "Name" }), _jsx("dd", { children: _jsx(ValOrDash, { val: debtor?.name }) }), _jsx("dt", { children: "Contact" }), _jsx("dd", { children: _jsx(ValOrDash, { val: debtor?.contactName }) }), _jsx("dt", { children: "Address" }), _jsx("dd", { children: _jsx(AddressFormatted, { address: debtor?.address }) })] }));
};
export default DebtorDefinitionList;
